export default __webpack_public_path__ + "static/media/goal.5e102849.svg";